/* import __COLOCATED_TEMPLATE__ from './dialog-actions.hbs'; */
/**

## Dialog Actions

Contextual component used for [Modals](/components/glass/dialog-modal.html),
[Blades](/components/glass/dialog-blade.html), and [Sheets](/components/glass/dialog-sheet.html)

### Parameters
@param {boolean} [isShowingSpinner=false] If true, shows a spinner in the footer
@param {string} [context=modal] Determines the parent context in which this footer is shown, which applies appropriate class name bindings

**/

import Component from '@ember/component';
import { computed } from '@ember/object';
import { CONTEXT } from '../utils/dialog-actions';

// eslint-disable-next-line ember/no-classic-classes
export default Component.extend({
  isShowingSpinner: false,
  context: CONTEXT.MODAL,
  classNames: ['dialog__actions'],
  classNameBindings: ['contextClass'],
  contextClass: computed('context', function () {
    switch (this.get('context')) {
      case CONTEXT.BLADE:
        return 'dialog--blade__actions';
      default:
        return '';
    }
  })
});